import { useEffect, useState } from 'react';
import getLanguageFromStorage from 'syf-js-utilities/helpers/getLanguageFromStorage';
import i18n from '../strings/i18n';
var useSelectedLanguage = function (_a) {
    var _b = _a === void 0 ? {} : _a, attachEvent = _b.attachEvent;
    var _c = useState(getLanguageFromStorage()), selectedLang = _c[0], setSelectedLang = _c[1];
    var handleLanguageChange = function () {
        var lang = selectedLang === 'en' ? 'es' : 'en';
        i18n.changeLanguage(lang);
        localStorage.setItem('language', lang);
        setSelectedLang(lang);
    };
    useEffect(function () {
        if (attachEvent) {
            // Attaches globally broadcast event
            i18n.on('languageChanged', function (language) {
                setSelectedLang(language);
            });
        }
    }, [attachEvent]);
    return {
        onLangChange: handleLanguageChange,
        selectedLang: selectedLang
    };
};
export default useSelectedLanguage;
//# sourceMappingURL=use-selected-language.js.map